import {httpIncidentAPI} from 'features/http/api/httpIncidentAPI';
import {
    getHttpIncidentFilterArray,
    HTTP_INCIDENTS_DEFAULT_SORT,
    HTTP_INCIDENTS_ORDER_FIELDS,
} from 'features/http/lib/httpFilters';
import {useHasTariffLimit, usePlugState} from 'entities/user';
import useCreateHttpMonitorButton from 'features/http/model/useCreateHttpMonitorButton';
import useListParams from 'shared/lib/hooks/useListParams';
import useResetPageOnEmpty from 'shared/lib/hooks/useResetPageOnEmpty';
import {getPollingInterval} from 'shared/api/pollingHelper';

export const useHttpIncidentsScreen = () => {
    const {args, sort, setSort, hasFilters} = useListParams({
        getFilters: getHttpIncidentFilterArray,
        defaultSort: HTTP_INCIDENTS_DEFAULT_SORT,
        sortFields: HTTP_INCIDENTS_ORDER_FIELDS,
    });
    const hasAccess = useHasTariffLimit('monitor_max_count_limit');
    const {isCreateOpen, isExceededOpen, handleOpen, handleClose} = useCreateHttpMonitorButton();

    const {data, isLoading, isFetching, refetch} = httpIncidentAPI.useGetHttpIncidentsAllQuery(args, {
        skip: !hasAccess,
        pollingInterval: getPollingInterval(),
    });

    const isRedirecting = useResetPageOnEmpty(data);

    const plugState = usePlugState({
        tariffField: 'monitor_max_count_limit',
        isLoading: isLoading || isRedirecting,
        isEmpty: data?.items?.length === 0 && data?.totalItems === 0,
        hasFilters,
    });

    return {
        data,
        isLoading,
        isFetching,
        refetch,
        sort,
        setSort,
        plugState,
        openCreate: handleOpen,
        closeCreate: handleClose,
        isCreateOpen,
        isExceededOpen,
    };
};

export default useHttpIncidentsScreen;
